/* eslint-disable consistent-this */
// This will allow us to set a limit (in milliseconds) on how often our handleScroll function can fire.
export const debounce = (func, wait, immediate) => {
  let timeout;

  return function () {
    // eslint-disable-next-line no-invalid-this
    const context = this,
      args = arguments;

    const later = function () {
      timeout = null;

      if (!immediate) {
        func.apply(context, args);
      }
    };

    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);

    if (callNow) {
      func.apply(context, args);
    }
  };
};
